module.exports = __webpack_public_path__ + "img/25T_510k_otc.9e805ade.jpg";